'use strict';

angular.module('ecrd.states').controller('PartialHistoryController', [
    'EcrdService',
    'CrfService',
    function(EcrdService, CrfService) {
        var vm = this;

        // El primer cambio, el de cambio de estado, del que parten los demás
        vm.stateChange = null;

        // Si tiene elementos restringidos por perfil
        vm.hasUnavailableElements = false;

        vm.$onInit = function() {
            vm.changes = vm.changes.slice();
            vm.stateChange = vm.changes.shift();

            if (vm.formId) {
                // Vemos si alguno de los elementos no disponibles corresponde a este formulario
                var formFieldsIds = CrfService.getForm(vm.formId).getFields().map(function(field) {
                    return field.getId();
                });
                var unavailableElements = EcrdService.getUnavailableElementsToCurrentProfile();

                for (var index = 0; index < unavailableElements.length; index++) {
                    var elementId = unavailableElements[index];

                    if (formFieldsIds.indexOf(elementId) > -1) {
                        vm.hasUnavailableElements = true;
                        break;
                    }
                }
            } else {
                vm.hasUnavailableElements = EcrdService.getUnavailableElementsToCurrentProfile().length > 0;
            }
        };
    },
]);
